// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 350px;
    font-family: "Roboto", Arial, sans-serif; 
    z-index: 1000;
  }
  
  .chatbot {
    border: 1px solid #ddd;
    border-radius: 12px;
    background-color: white;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    max-height: 500px;
    overflow: hidden;
  }
  
  .chatbot-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #2596be; 
    color: white;
    padding: 12px;
    font-size: 16px;
    font-weight: 600; 
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  
  .close-button {
    background: none;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
  }
  
  .chatbot-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 10px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .message {
    display: inline-block;
    margin: 5px 0;
    padding: 10px 15px;
    border-radius: 16px;
    font-size: 15px; 
    font-weight: 400; 
    line-height: 1.5; 
    max-width: 80%;
    word-wrap: break-word;
  }
  
  .message.bot {
    background-color: #e6f5fa;
    color: #333;
    align-self: flex-start;
    text-align: left;
  }
  
  .message.user {
    background-color: #2596be; 
    color: white;
    align-self: flex-end;
    text-align: right;
  }
  
  .chatbot-footer {
    display: flex;
    gap: 8px;
    padding: 10px;
    background-color: white;
    border-top: 1px solid #ddd;
  }
  
  .chatbot-footer input {
    flex: 1 1;
    padding: 12px;
    border-radius: 16px;
    border: 1px solid #ddd;
    font-size: 14px;
    font-family: "Roboto", Arial, sans-serif; 
  }
  
  .chatbot-footer button {
    background-color: #2596be; 
    color: white;
    border: none;
    padding: 10px 14px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 500; 
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .chatbot-footer button:hover {
    background-color: #1b7892; 
  }
  
  .chatbot-recommendations {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 0;
    align-items: center;
    animation: fadeIn 0.4s ease;
  }
  
  .recommendation-button {
    background-color: #2596be; 
    color: white;
    border: none;
    border-radius: 32px;
    width: 80%;
    align-items: center;
    padding: 8px 12px;
    font-size: 14px; 
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .recommendation-button:hover {
    background-color: #1b7892; 
  }
  
  .chat-icon {
    width: 60px;
    height: 60px;
    background-color: #2596be; /* Theme color */
    color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  .chat-icon:hover {
    background-color: #1b7892; 
  }
  
  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(10px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/dashboard/ChatBot.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF","sourcesContent":[".chatbot-container {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    width: 350px;\n    font-family: \"Roboto\", Arial, sans-serif; \n    z-index: 1000;\n  }\n  \n  .chatbot {\n    border: 1px solid #ddd;\n    border-radius: 12px;\n    background-color: white;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n    display: flex;\n    flex-direction: column;\n    max-height: 500px;\n    overflow: hidden;\n  }\n  \n  .chatbot-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #2596be; \n    color: white;\n    padding: 12px;\n    font-size: 16px;\n    font-weight: 600; \n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n  }\n  \n  .close-button {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 18px;\n    cursor: pointer;\n  }\n  \n  .chatbot-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 10px;\n    background-color: #f9f9f9;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .message {\n    display: inline-block;\n    margin: 5px 0;\n    padding: 10px 15px;\n    border-radius: 16px;\n    font-size: 15px; \n    font-weight: 400; \n    line-height: 1.5; \n    max-width: 80%;\n    word-wrap: break-word;\n  }\n  \n  .message.bot {\n    background-color: #e6f5fa;\n    color: #333;\n    align-self: flex-start;\n    text-align: left;\n  }\n  \n  .message.user {\n    background-color: #2596be; \n    color: white;\n    align-self: flex-end;\n    text-align: right;\n  }\n  \n  .chatbot-footer {\n    display: flex;\n    gap: 8px;\n    padding: 10px;\n    background-color: white;\n    border-top: 1px solid #ddd;\n  }\n  \n  .chatbot-footer input {\n    flex: 1;\n    padding: 12px;\n    border-radius: 16px;\n    border: 1px solid #ddd;\n    font-size: 14px;\n    font-family: \"Roboto\", Arial, sans-serif; \n  }\n  \n  .chatbot-footer button {\n    background-color: #2596be; \n    color: white;\n    border: none;\n    padding: 10px 14px;\n    border-radius: 16px;\n    font-size: 14px;\n    font-weight: 500; \n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .chatbot-footer button:hover {\n    background-color: #1b7892; \n  }\n  \n  .chatbot-recommendations {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 10px 0;\n    align-items: center;\n    animation: fadeIn 0.4s ease;\n  }\n  \n  .recommendation-button {\n    background-color: #2596be; \n    color: white;\n    border: none;\n    border-radius: 32px;\n    width: 80%;\n    align-items: center;\n    padding: 8px 12px;\n    font-size: 14px; \n    font-weight: 500;\n    text-align: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .recommendation-button:hover {\n    background-color: #1b7892; \n  }\n  \n  .chat-icon {\n    width: 60px;\n    height: 60px;\n    background-color: #2596be; /* Theme color */\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 24px;\n    cursor: pointer;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  .chat-icon:hover {\n    background-color: #1b7892; \n  }\n  \n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
